<template>
    <zen-slide-in
        :isOpen="isOpen"
        title="Edit Team"
        :error="error"
        @close="$emit('close')"
    >
        <template #body>
            <div class="space-y-4">
                <div>
                    <label
                        for="edit-team-name"
                        class="block text-sm font-medium text-taupe-700 mb-1"
                        >Name</label
                    >
                    <input
                        id="edit-team-name"
                        :value="data.name"
                        @input="
                            $emit('update:data', {
                                ...data,
                                name: $event.target.value,
                            })
                        "
                        type="text"
                        class="block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6"
                        placeholder="Team name"
                        data-testid="edit-team-name"
                    />
                </div>
                <div>
                    <label
                        for="edit-team-description"
                        class="block text-sm font-medium text-taupe-700 mb-1"
                        >Description</label
                    >
                    <textarea
                        id="edit-team-description"
                        :value="data.description"
                        @input="
                            $emit('update:data', {
                                ...data,
                                description: $event.target.value,
                            })
                        "
                        rows="3"
                        class="block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6"
                        placeholder="Optional description"
                        data-testid="edit-team-description"
                    />
                </div>
            </div>
        </template>
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary"
                size="medium"
                :processing="processing"
                :disabled="!data.name?.trim()"
                @click="$emit('confirm')"
            >
                Save
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script>
export default {
    name: 'EditTeamSlideIn',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        error: {
            type: [String, Object],
            default: null,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm', 'update:data'],
}
</script>
